import { render } from "./NotToday.vue?vue&type=template&id=0faf2f66&scoped=true"
import script from "./NotToday.vue?vue&type=script&lang=js"
export * from "./NotToday.vue?vue&type=script&lang=js"

import "./NotToday.vue?vue&type=style&index=0&id=0faf2f66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0faf2f66"

export default script